import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit
} from '@angular/core';import { AppHeaderComponent } from './header/header.component';
import { AppSidebarComponent } from './sidebar/sidebar.component';
import { MenuItems } from '../../shared/menu-items/menu-items';/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: ['full.component.scss']
})
export class FullComponent implements OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  isMenuOpen = true;
  showMenuAdmin:boolean = false;
  showMenuUser:boolean = false;
  showMenuCompany:boolean = false;
  showMenuKudo:boolean = false;
  showMenutags:boolean = false;
  showMenuAnalytic:boolean = false;
  contentMargin: number ;
  private _mobileQueryListener: () => void;  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

  }  WindowResize(e) {
    setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 260);
    }  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }  onToolbarMenuToggle() {
    this.isMenuOpen = !this.isMenuOpen;
       if(!this.isMenuOpen) {
      this.contentMargin = 70;
    } else {
      this.contentMargin = 240;
    }
  }
  toggleMenuAdmin() {
    this.showMenuAdmin = !this.showMenuAdmin;
 }
 toggleMenuUser() {
  this.showMenuUser = !this.showMenuUser;
}
toggleMenuCompany() {
  this.showMenuCompany = !this.showMenuCompany;
}
toggleMenuAnalytic() {
  this.showMenuAnalytic = !this.showMenuAnalytic;
}
toggleMenuKudo() {
  this.showMenuKudo = !this.showMenuKudo;
}
toggleMenuTags(){
  this.showMenutags= !this.showMenutags;
}
  ngAfterViewInit() {}
}


